const CardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0.79 49 68.37"
    {...props}
  >
    <path fill="#D5BB43" d="M0 .791h49v68.372H0z" />
    <path
      fill="#857A3A"
      d="M4.179 4.969h40.643v24.69H4.179zM4.179 33.837h40.643v31.147H4.179z"
    />
  </svg>
);

export default CardIcon;
